export const SURFACE_STORE_APP_ID: string = '58914';
export const SURFACE_IMPORT_CREDENTIALS: string = 'bc_import_credentials';
export const SURFACE_IMPORT_CREDENTIALS_STORE_URL: string = 'store_url';
export const SURFACE_IMPORT_JOIN_LIMIT = 10;
export const FULL_SERVICE_SKU_LIMIT: number = 100000;
export const APPROACHING_SKU_LIMIT_THRESHOLD: number = 0.9;
